module.exports = __webpack_public_path__ + "img/4.0372b691.jpg";